import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Hyphen.svg'


const _hoisted_1 = { class: "sensorAlarms" }
const _hoisted_2 = { class: "sensorAlarms__header" }
const _hoisted_3 = { class: "chooseDate" }
const _hoisted_4 = { class: "date-block" }
const _hoisted_5 = { class: "date-inputs" }
const _hoisted_6 = { class: "input" }
const _hoisted_7 = { class: "input" }
const _hoisted_8 = {
  key: 0,
  class: "date-error"
}
const _hoisted_9 = {
  key: 1,
  class: "date-error"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "sensorAlarms__noData"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Table = _resolveComponent("Table")!
  const _component_AddSensorAlarmComment = _resolveComponent("AddSensorAlarmComment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              class: "week-nav-button",
              variant: "bordered",
              title: _ctx.$t('prevWeek') || 'Prev week',
              onClick: _ctx.prevWeek
            }, null, 8, ["title", "onClick"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.startTime,
                name: "startTime",
                onChange: _ctx.changeDate
              }, null, 8, ["value", "onChange"])
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              class: "date-img",
              src: _imports_0,
              alt: "Hyphen"
            }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Calendar, {
                type: "date",
                format: "DD/MM/YYYY",
                value: _ctx.dateRange.endTime,
                name: "endTime",
                onChange: _ctx.changeDate
              }, null, 8, ["value", "onChange"])
            ]),
            _createVNode(_component_Button, {
              class: "update-date-button",
              variant: "filled",
              style: {"margin-left":"12px"},
              title: _ctx.$t('update'),
              disabled: !_ctx.isDateCorrect || !_ctx.isSixMonthValid,
              onClick: _ctx.loadAlarms
            }, null, 8, ["title", "disabled", "onClick"]),
            (_ctx.canGoNextWeek)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "week-nav-button",
                  variant: "bordered",
                  style: {"margin-left":"12px"},
                  title: _ctx.$t('nextWeek') || 'Next week',
                  onClick: _ctx.nextWeek
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isSixMonthValid)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('errorSixMonths') || 'Range cannot exceed 6 months'), 1))
            : _createCommentVNode("", true),
          (!_ctx.isDateCorrect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('errorDate')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.alarmsData.length && _ctx.isDateCorrect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_Table, {
            data: _ctx.alarmsData,
            columns: _ctx.columns,
            onCommentSensorAlarm: _ctx.openCommentModal,
            onCommentSensorAlarmBulk: _ctx.openBulkCommentModal
          }, null, 8, ["data", "columns", "onCommentSensorAlarm", "onCommentSensorAlarmBulk"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('noAlarms') || 'No alarms found for this period'), 1)
        ])),
    _createVNode(_component_AddSensorAlarmComment, {
      "show-modal": _ctx.showCommentModal,
      "active-alarm": _ctx.activeAlarm,
      loading: _ctx.commentLoading,
      onCloseModal: _ctx.closeCommentModal,
      onSaveComment: _ctx.saveComment
    }, null, 8, ["show-modal", "active-alarm", "loading", "onCloseModal", "onSaveComment"])
  ]))
}